module.exports = __webpack_public_path__ + "img/Changeovers.87c966ff.png";